import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
// Add font preloading to improve font loading performance
const preloadFonts = () => {
  const fontLinks = [{
    rel: 'preload',
    href: 'https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap',
    as: 'style'
  }];
  fontLinks.forEach(font => {
    const link = document.createElement('link');
    link.rel = font.rel;
    link.href = font.href;
    link.as = font.as;
    link.crossOrigin = 'anonymous';
    document.head.appendChild(link);
  });
};
// Execute font preloading
preloadFonts();
render(<App data-id="element-735" />, document.getElementById('root'));